export const bankingAccountConstants = {
  SET_BUSINESS_ACCOUNTS: 'SET_BUSINESS_ACCOUNTS',
  CLEAR_BUSINESS_ACCOUNTS: 'CLEAR_BUSINESS_ACCOUNTS_SUCCESS',
}
